export default "__VITE_PUBLIC_ASSET__d53dc012__"